import { render, staticRenderFns } from "./LeaveApproverForm.vue?vue&type=template&id=d4b19e0a"
import script from "./LeaveApproverForm.vue?vue&type=script&lang=js"
export * from "./LeaveApproverForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports